import * as React from 'react';

// components
import Input from '../shared/Input';
import { Button, Alert } from 'reactstrap';

// final form
import { Form, Field } from 'react-final-form';

// networking
import AxiosHelper from 'services/AxiosHelper';
import * as axios from 'axios';
import { AxiosError, AxiosResponse } from 'axios';

// types
import { LoginResponse } from './types';
import Spinner from 'components/shared/Spinner';
import { handleAxiosErrorWithValidation } from 'util/Misc';

/**
 * LoginRecovery component
 *
 * @class LoginRecovery
 * @extends {React.PureComponent<any>}
 */
class LoginRecovery extends React.PureComponent<any> {
	private cancelToken: any = null;

	public componentWillUnmount() {
		if (this.cancelToken) {
			this.cancelToken();
		}
	}

	public submit = (formValues: any): Promise<void | Record<string, string>> => {
		if (this.cancelToken) {
			this.cancelToken();
		}

		const url = `/ajax/login-recovery/`;

		const searchParams = new URLSearchParams(this.props.location ? this.props.location.search : '');
		const redirectUrl = searchParams.get('ReturnUrl');

		return AxiosHelper.post(url, formValues, {
			cancelToken: new axios.default.CancelToken((token) => {
				this.cancelToken = token;
			}),
		})
			.then((response: AxiosResponse<LoginResponse>) => {
				if (response.data.success) {
					window.location.href = redirectUrl ? redirectUrl : '/';
				} else {
					window.location.href = response.data.redirectUrl;
				}
			})
			.catch((error: AxiosError) => {
				return handleAxiosErrorWithValidation(error, null);
			})
			.then((promise: any) => {
				this.cancelToken = null;
				return promise;
			});
	};

	public render() {
		return (
			<div className="login-form">
				<div>
					<h2 className="login-form-heading">
						You have requested to log in with a recovery code. This login will not be remembered until you
						provide an authenticator app code at log in or disable 2FA and log in again.
					</h2>
				</div>
				<Form
					onSubmit={this.submit}
					subscription={{ submitting: true, submitError: true }}
					render={({ handleSubmit, submitError, submitting }) => (
						<form onSubmit={handleSubmit} className="login-form">
							{submitError ? (
								<div>
									<Alert color="danger">{submitError}</Alert>
								</div>
							) : null}

							<Field
								name="recoveryCode"
								placeholder="#123456"
								type="text"
								autoFocus
								className="login-form__row login-form__text-input"
								indicateDirty={false}
								component={Input}
							/>

							<div className="login-form__actions form-group">
								<Button
									type="submit"
									disabled={submitting}
									color="primary"
									data-testid="login-recovery-code-btn"
									className="btn login-form__action login-form__submit-btn"
								>
									Login
								</Button>
							</div>
							<div className="login-form__actions form-group">{submitting ? <Spinner /> : null}</div>
						</form>
					)}
				/>
			</div>
		);
	}
}

export default LoginRecovery;
